module.exports = __webpack_public_path__ + "img/icon3-light.51ca74fb.png";